import React, { useState } from 'react'
import useWindowSize from 'shared/hooks/window-size'
import { AboutPageContext } from './context'
import { AboutPageGlobalStyles, AboutPageGradient, AboutPageContainer } from './style'
import { IHoverImage } from './types'
import Header from './header'
import Info from './info'
import News from './news'
import Contact from './contact'
import Team from './team'
import Footer from './footer'

const AboutPage = () => {
    const { width: windowWidth = window.innerWidth, height: windowHeight = window.innerHeight } = useWindowSize()
    const [hoverImages, setHoverImages] = useState<IHoverImage[]>([])
    const addHoverImage = (image: IHoverImage) => {
        setHoverImages([...hoverImages, image])
    }
    const clearHoverImages = () => {
        setHoverImages([])
    }
    return (
        <AboutPageContext.Provider
            value={{
                hoverImages,
                addHoverImage,
                clearHoverImages,
                windowWidth,
                windowHeight,
            }}
        >
            <AboutPageGlobalStyles />
            <AboutPageContainer>
                <Header />
                <AboutPageGradient>
                    <Info />
                    <News />
                </AboutPageGradient>
                <Contact />
                <Team />
                <Footer />
            </AboutPageContainer>
        </AboutPageContext.Provider>
    )
}

export default AboutPage
